module.exports = __webpack_public_path__ + "img/reg20.d0e7aaa1.png";